<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of lastBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="btnHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'AgreementBtn',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        btnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'handleSave',
            params: 0,
            key: 'save',
          },
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'handleSave',
            params: 1,
            key: 'approval',
          },
          {
            title: '复制',
            type: 'primary',
            clickName: 'copyHandler',
            params: 'agreement',
            key: 'copy',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'deleteHandler',
            key: 'delete',
          },
          {
            title: '创建销售合同',
            type: 'primary',
            clickName: 'createContractHandler',
            key: 'createContract',
          },
        ],
        lastBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      btnHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      disabledBtnHandler(contractStatus) {
        this.lastBtnList = this.btnList.map((item) => {
          if (['ZT06', 'ZT05'].includes(contractStatus)) {
            // 已保存
            if (['save', 'delete', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (['ZT02'].includes(contractStatus)) {
            return {
              ...item,
              disabled: true,
            };
          } else if (contractStatus == 'ZT03') {
            if (['save', 'copy', 'createContract'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == '' || !contractStatus) {
            console.log('buttons', contractStatus);
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else {
            console.log('buttons', contractStatus);
            if (['save', 'approval', 'delete'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.lastBtnList.every((item) => item.disabled);
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          this.disabledBtnHandler(val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
